import { Pipe, PipeTransform } from '@angular/core';
import { AlOptionItem } from '../../types';

@Pipe({
  name: 'alFilter'
})
export class AlFilterPipe implements PipeTransform {

  transform(items: AlOptionItem[], searchTerm: string): any[] {
    if (!items) {
      return [];
    }

    if (!searchTerm) {
      return items;
    }

    return items.filter(item => {
      return item.label.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
    });
  }

}
